import * as Yup from "yup";
import { Formik } from "formik";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Loader } from "../../../components";
import { useAlert, useAxios, useComponent } from "../../../hooks";
import { eventBokingObject } from "./form components/eventBookingObject";
import Form from "./form components/Form";

const AddBooking = () => {
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useComponent();
  const { state } = useLocation();
  const { eventID, id } = useParams();
  const axiosApi = useAxios({ baseURL: "mox_api_2" });

  const [formData, setFormData] = useState(eventBokingObject);
  const [eventList, setEventList] = useState([]);
  const [badgeOptions, setBadgeOptions] = useState([]);
  const { visitorData } = useSelector((state) => state.memberDetails);

  // ✅ popup state
  const [openPopup, setOpenPopup] = useState(false);
  const [latestData, setLatestData] = useState(null);

  // ✅ validation schema
  const validationSchema = Yup.object().shape({
    visitorData: Yup.array().of(
      Yup.object().shape({
        first_name: Yup.string().required("First Name is requied"),
        last_name: Yup.string().required("Last Name is requied"),
        email_id: Yup.string()
          .email("Invalid email format")
          .required("Email is required"),
        phone_number: Yup.string()
          .matches(/^\+?[1-9]\d{1,14}$/, "Invalid phone number format")
          .required("Phone number is required"),
      })
    ),
    badgeID: Yup.string().required("Select Badge"),
    eventID: Yup.string().required("Event is required"),
  });

  function formatBookingData(data) {
    return {
      event_id: data.eventID || "",
      booking_id: data.badgeID || "",
      first_name: data.visitorData?.[0]?.first_name || "",
      last_name: data.visitorData?.[0]?.last_name || "",
      phone_number: data.visitorData?.[0]?.phone_number || "",
      email_id: data.visitorData?.[0]?.email_id || "",
      total_bookings: data.visitorData ? data.visitorData.length : 0,
      badges: [
        {
          badge_id: data.badgeID || "",
        },
      ],
    };
  }

  const handleSubmit = async (values, { resetForm }) => {
    axiosApi({
      url:
        "/event/booking/visitor-information" +
        (values.ID
          ? "?visitor_id=" + values.visitor_id + "&is_update=" + true
          : ""),
      method: "POST",
      data: {
        ...formatBookingData(values),
      },
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          resetForm();
        } else {
          // store latest data for popup
          setLatestData(response.data);
          setOpenPopup(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // ✅ handle update booking if Yes clicked
  const handleUpdateBooking = () => {
    if (!latestData) return;

    setFormData({
      ID: latestData.values,
      eventID: latestData.event_id,
      badgeID: latestData.badges[0].badge_id,
      visitorData: [
        {
          first_name: latestData.first_name,
          last_name: latestData.last_name,
          gender: latestData.gender,
          phone_number: latestData.phone_number,
          email_id: latestData.email_id,
        },
      ],
    });

    setOpenPopup(false);
  };

  useEffect(() => {
    axiosApi({
      url: "/entry/entry/entity-list?entity_type=1",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setEventList(response.data);
      } else {
        setEventList([]);
      }
    });
  }, []);

  return (
    <Loader>
      <Grid container padding={5}>
        <Grid container justifyContent={"center"}>
          <Grid
            item
            container
            sx={{
              "@media (min-width:690px)": {
                width: "50%",
              },
            }}
          >
            <Formik
              initialValues={formData}
              enableReinitialize
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formikProps) => (
                <form
                  onSubmit={formikProps.handleSubmit}
                  style={{ width: "100%" }}
                >
                  <Form
                    eventList={eventList}
                    badgeList={badgeOptions}
                    setBadgeList={setBadgeOptions}
                    formik={formikProps}
                  />
                </form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Grid>

      {/* ✅ Popup */}
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
        <DialogTitle>Update Booking</DialogTitle>
        <DialogContent>
          Do you want to update booking with the new information?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFormData({
                eventID: "",
                badgeID: "",
                visitorData: [
                  {
                    first_name: "",
                    last_name: "",
                    gender: "",
                    phone_number: "",
                    email_id: "",
                  },
                ],
              });
              setOpenPopup(false);
            }}
            color="error"
          >
            No
          </Button>
          <Button
            onClick={handleUpdateBooking}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Loader>
  );
};

export default AddBooking;
